import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "react-i18next";

const FacebookCallback = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { loginWithFacebookCode, loginWithFacebook } = useAuth();

  const consumePostAuthRedirect = () => {
    if (typeof window === "undefined") return null;
    try {
      const value = window.sessionStorage.getItem("postAuthRedirect");
      if (value) {
        window.sessionStorage.removeItem("postAuthRedirect");
      }
      if (value && typeof value === "string" && value.startsWith("/")) {
        return value;
      }
      return null;
    } catch (_err) {
      return null;
    }
  };

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      console.debug("[FacebookCallback] Processing OAuth callback");
    }

    // Βρες το locale prefix (π.χ. /el ή /en)
    const match = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)\b/);
    const prefix = match ? `/${match[1]}` : "";

    // Αναζήτηση για 'code' στο query string (authorization code flow)
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");

    // Αναζήτηση για 'access_token' στο hash fragment (implicit/legacy flow)
    const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const accessToken = hashParams.get("access_token");

    // Πρέπει να είναι 100% ΙΔΙΟ με αυτό που δήλωσες στο Facebook και το initial redirect!
    const redirect_uri = `${window.location.origin}${prefix}/auth/facebook/callback`;

    if (code) {
      if (process.env.NODE_ENV !== "production") {
        console.debug("[FacebookCallback] Authorization code flow detected");
      }
      if (!state) {
        navigate(`${prefix}/login`);
        return;
      }
      loginWithFacebookCode(code, redirect_uri, state).then((res) => {
        if (res?.success) {
          const postAuthRedirect = consumePostAuthRedirect();
          navigate(postAuthRedirect || `${prefix}/client/dashboard`, { replace: true });
        } else {
          navigate(`${prefix}/login`, { replace: true });
        }
      });
    } else if (accessToken) {
      if (process.env.NODE_ENV !== "production") {
        console.debug("[FacebookCallback] Access token flow detected");
      }
      loginWithFacebook(accessToken).then((res) => {
        if (res?.success) {
          const postAuthRedirect = consumePostAuthRedirect();
          navigate(postAuthRedirect || `${prefix}/client/dashboard`, { replace: true });
        } else {
          navigate(`${prefix}/login`, { replace: true });
        }
      });
    } else {
      console.warn("[FacebookCallback] No code or access_token found in URL!");
      navigate(`${prefix}/login`, { replace: true });
    }
  }, [loginWithFacebookCode, loginWithFacebook, navigate]);


  return <div>{t("connecting") || "Connecting..."}</div>;
};

export default FacebookCallback;
